import { Box, Button } from "@material-ui/core";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateTabSelected } from "../../../../store/checkoutPage.slide";
import { useSelectAddOnsExtraServicesStyles } from "./AddOnItem.styles";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import OverrideTheme from "../../../../components/OverrideTheme";
import { AddOnItem } from "./AddOnItem";
import { RootState } from "../../../../app/rootReducer";
import { hasAddons, quoteAvailableSubscriptions } from "../../../../app/utils";
import { SubscriptionItem } from "./SubscriptionItem";

export const TabAddOn = ({ quoteId }: { quoteId: string }) => {
  const { isMoreThanSm } = useBreakpoint();
  const classes = useSelectAddOnsExtraServicesStyles();
  const dispatch = useDispatch();

  const { quote } = useSelector((state: RootState) => state.quote);
  const { subscriptions } = useSelector((state: RootState) => state.subscriptions);

  const availableSubscriptions = useMemo(() => {
    if (subscriptions && quote) return quoteAvailableSubscriptions(quote, subscriptions);
    return [];
  }, [subscriptions, quote]);

  if (!quote) return null;
  return (
    <Box padding={isMoreThanSm ? "0px 14px" : 0} width={"100%"}>
      <OverrideTheme>
        <Box>
          {quote.addons &&
            quote.addons.map((item, index) => {
              if (!quote.addons) return null;
              const isfirst = index === 0;

              return <AddOnItem isfirst={isfirst} item={item} key={index} quoteId={quoteId} />;
            })}
        </Box>
        {!!availableSubscriptions.length &&
          availableSubscriptions.map((item, index) => {
            const selected = quote.subscriptions?.some((i) => i.productId === item.id) ?? false;
            const isFirst = index === 0;
            const hasAddon = hasAddons(quote.addons);
            const hasFirstBorderTop = isFirst && hasAddon;
            return (
              <SubscriptionItem
                item={item}
                quoteId={quoteId}
                selected={selected}
                isFirst={isFirst}
                firstBorderTop={hasFirstBorderTop}
                key={index}
              />
            );
          })}
      </OverrideTheme>

      <Box textAlign="center" width={"100%"}>
        <Button
          className={classes.next}
          onClick={() => {
            dispatch(updateTabSelected("pay-deposit"));
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};
